import {Request} from '@group-devs/yfp7-global-modules'
import {Nav, NavDropdown, Image, Row, Col} from 'react-bootstrap'
import {FaBars, FaTimes, FaChevronDown, FaPen} from "react-icons/fa"
import Link from 'next/link' 
import { useState } from 'react'
import { isDomain } from '@group-devs/yfp7-global-modules/utils/general'

const request = new Request(process.env.apiDomain)

function WDropdownNav(props) {

    const [isOpen, setIsOpen] = useState(false)
    
    const site_owner = props.auth.site_owner
    
    const endPoint = process.env.s3EndPoint.replace('https://','');
    const bucketName = process.env.s3Bucket;
    const IMAGE_PATH = 'https://'+bucketName+'.'+endPoint;

    const accountId = props.auth.site_owner ? props.site.accountId : null;
    const contactId = props.auth.site_user ? props.auth.contactId : null;
    const userId = props.auth.site_owner ? props.auth.userId : null;

    const {data: business} = request.website.swrSite(props.site.accountId, "BC")
    
    const name = props.auth.name
    const email = props.auth.site_user_email;
    const myProfileLink = props.auth.site_owner ? '/account-profile' : '/myprofile';

    const {data: profile} = request.account.swrAccountProfile(accountId);
    const {data: contactAccount} = request.contacts.swrAccount(contactId);
    const avatar = contactAccount && contactAccount.contact.profile.image != "" && contactAccount.contact.profile.image != null ? IMAGE_PATH+'/'+contactAccount.contact.profile.image : '';

    const image = site_owner && profile ? profile.avatar : (contactId ? avatar : '');
    const height = props.auth.site_owner ? '145px' : '95px';

    const {data: user} = request.account.swrUserProfile(userId);
    const auth_key = user ? user.user.auth_key : '';

    const businessUrl = business ? (isDomain(business.url) ? 'www.'+business.url : business.url) : '';

    return (
        <div className="logo-dropdown leftNav">
            <NavDropdown 
                onToggle={(val) => setIsOpen(val)}
                title={
                <div>
                    <Image width={26} src="/images/general/img-wellness-white-01.svg" className="d-lg-inline-block d-none"/>
                    <FaChevronDown className="ml-2 d-lg-inline-block d-none" size="12"/>
                    {isOpen 
                        ? <FaTimes className="d-lg-none d-block" size="23" color="#fff"/> 
                        : <FaBars className="d-lg-none d-block" size="23" color="#fff"/>
                    }
                </div>} id="basic-nav-dropdown" className="">
                {business ? 
                    <div>
                        <div className="d-lg-none d-flex align-items-center py-2 px-2">
                            <Image width={35} height={35} src={image} className="img-fluid rounded-circle mr-2"/>
                            <div>
                                <h6 className="mb-0">{name}</h6>
                                <p className="mb-0"><small>{email}</small></p>
                            </div>
                            <Link href={myProfileLink}><a className="ml-auto py-2 px-sm-3 px-1"><FaPen size="16"/></a></Link>
                        </div>
                        <hr className="m-0" />
                        <Link href={`https://${businessUrl}/home`}><a className="d-block py-2 px-lg-4 px-2">
                            <Image width={30} src="/images/general/img-business-blue-01.svg" alt="Visit the Business Center" className="mr-3"/>Visit the Business Center
                        </a></Link>
                        <hr className="m-0" />
                        <Link href={`https://${businessUrl}/explore`}><a className="d-block py-2 px-lg-4 px-2">
                            <Image width={30} src="/images/general/img-explore-opportunity-blue-01.svg" alt="Explore Business" className="mr-3"/>Explore Opportunity
                        </a></Link>
                        <hr className="m-0"/>
                        {contactId == null ? 
                            <>
                            <Link href={process.env.authDomain+'/autologin?ref='+auth_key+'&redirect=dashboard'}><a className="d-block py-2 px-lg-4 px-2">
                                <Image width={30} src="/images/general/img-dashboard-blue-01.svg" alt="YFP Dashboard" className="mr-3"/>YFP Dashboard
                            </a></Link>
                            <hr className="m-0" />
                            </>
                        : ''}
                    </div>
                : null }
            </NavDropdown>

            <style jsx global>{`
                
                .logo-dropdown .dropdown{
                    position:inherit;
                }

                .logo-dropdown .dropdown-menu{
                    padding:0;
                    width:320px;
                    min-width:320px;
                    border-radius:0;
                    display:block!important;
                    height:0;
                    transition:height .4s ease-in-out;
                    overflow:hidden;
                    border:none;
                    box-shadow:-1px 9px 9px -3px rgba(0,0,0,0.19);
                }

                .logo-dropdown .dropdown-menu a{
                    color:#212529;
                }

                .logo-dropdown .dropdown-menu.show{
                    height: ${height};
                    transition:height .4s ease-in-out
                }

                @media (min-width: 992px) and (max-width: 1199.98px){

                }

                @media (min-width: 768px) and (max-width: 991.98px){

                }

                @media(max-width:991.98px){

                    .logo-dropdown .dropdown-menu{
                        width:100%;
                        min-width:100%;
                    }

                    .logo-dropdown .dropdown-menu.show{
                        height:calc(100vh - 103px);
                        overflow-y:scroll;
                    }

                }
                
                @media(max-width:767.98px){

                }
                
                @media(max-width:575.98px){

                    .logo-dropdown .dropdown-menu,
                    .logo-dropdown .dropdown-menu h6{
                        font-size:0.8rem;
                    }

                }
                
            `}</style>

        </div>
    )
}

export default WDropdownNav